import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Gallery, GalleryCreate, GalleryUpdate, GalleryMedia, GalleryMediaCreate } from '../models/gallery.interface';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {
  private apiUrl = `${environment.apis.base}/galleries`;

  constructor(private http: HttpClient) { }

  getGalleries(activeOnly: boolean = false): Observable<Gallery[]> {
    return this.http.get<Gallery[]>(`${this.apiUrl}/`, { params: { active_only: activeOnly } });
  }

  getGallery(id: number): Observable<Gallery> {
    return this.http.get<Gallery>(`${this.apiUrl}/${id}`);
  }

  createGallery(data: GalleryCreate): Observable<Gallery> {
    return this.http.post<Gallery>(`${this.apiUrl}/`, data);
  }

  updateGallery(id: number, data: GalleryUpdate): Observable<Gallery> {
    return this.http.put<Gallery>(`${this.apiUrl}/${id}`, data);
  }

  deleteGallery(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  uploadMedia(galleryId: number, file: File): Observable<GalleryMedia> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<GalleryMedia>(`${this.apiUrl}/${galleryId}/media/upload`, formData);
  }

  deleteMedia(mediaId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/media/${mediaId}`);
  }
}
